import hybrid from '@zoom/hybrid-jssdk';

import {CLIENT_NOTIFICATIONS} from './consts';
import {global as Bus} from './EventBus';
import {inZoomClient, inZoomMobileClient} from './integration';
/**
 * init hybrid app bridge
 * All events must be registered here
 */
export async function initHybridAppBridge() {
  initHybridAppBridge.promise ??= hybrid.appBridge.config({
    subscribe: [
      {
        service: 'unifywebview',
        eventNames: ['DLEv_RecvWebviewMessage'],
      },
    ],
  });

  await initHybridAppBridge.promise;

  return hybrid.appBridge;
}

/**
 * Initializes the hybrid-jssdk config by env and
 * registers the global notification handlers for ZPNS, client events
 */
export const initHybridConfig = () => {
  if (inZoomClient) {
    if (window.__system_params__?.platform === 'mac') {
      hybrid.config({
        platform: {
          macOrIOSJSBridgeObject:
            // Zoom client 6.x unify WebView
            // !! uses special calendarUIJSObj namespace !!
            // !! hybrid will only have access to JSBridge fns within calendarUIJSObj !!
            window.webkit?.messageHandlers?.calendarUIJSObj ??
            // Zoom client 5.x
            window.webkit?.messageHandlers?.jsOCHelper,
        },
      });
    }
  } else if (inZoomMobileClient) {
    // Add any mobile config here
  }

  // Register global message handler
  const messageHandler = (message) => {
    if (!message.returnCode) {
      if (message.result && message.result.notification) {
        const notificationType = message.result.notification;
        console.warn('INFO', `Get notification: ${notificationType}`, message);
        switch (notificationType) {
          case CLIENT_NOTIFICATIONS.onTokenRefresh:
            Bus.emit('refreshToken', message.result);
            break;
          default:
            if (notificationType) {
              Bus.emit(notificationType, message);
            }
            break;
        }
      } else if (message.type === 'event') {
        const eventName = message.name;
        switch (eventName) {
          case CLIENT_NOTIFICATIONS.onThemeModeChange:
            Bus.emit('themeModeChanged', message);
            break;
          default:
            break;
        }
      }
    }
  };
  hybrid.bridge.getInstance().registerNotificationHandler(messageHandler);
};
